var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStart3 = function SvgIconStart3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.34 11.273V6.636H6.24V5.71C6.24 3.662 4.538 2 2.44 2H.54v1.855h1.9c1.05 0 1.9.83 1.9 1.854v5.564h.001-.001c0 2.048 1.702 3.71 3.8 3.71V22.4h1.9v-7.418h4.357l3.528 3.444a2.7 2.7 0 0 0-.285 1.192c0 1.537 1.276 2.782 2.85 2.782s2.85-1.245 2.85-2.782-1.276-2.782-2.85-2.782c-.439 0-.85.105-1.222.278l-2.185-2.132h2.457zm-2.85 7.418c.525 0 .95.415.95.927a.94.94 0 0 1-.95.927.94.94 0 0 1-.95-.927c0-.512.425-.927.95-.927"
  })));
};
export default SvgIconStart3;